// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#reportBox {
    width: 95vw;
    margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/reportQuery/ReportQuery.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;AAClB","sourcesContent":["#reportBox {\n    width: 95vw;\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
